import { render } from "./EditWorkspaceModal.vue?vue&type=template&id=96d299f8&scoped=true"
import script from "./EditWorkspaceModal.vue?vue&type=script&lang=js"
export * from "./EditWorkspaceModal.vue?vue&type=script&lang=js"

import "./EditWorkspaceModal.vue?vue&type=style&index=0&id=96d299f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d299f8"]])

export default __exports__